type PdfTemplateCache = { bytes: Uint8Array | null };

export async function loadPdfTemplateBytes(
  cache: PdfTemplateCache,
  embedded: Uint8Array | undefined | null,
  url: string,
  label: string,
): Promise<Uint8Array> {
  if (cache.bytes) return cache.bytes;
  if (embedded?.byteLength) {
    cache.bytes = embedded;
    return embedded;
  }
  const res = await fetch(url);
  if (!res.ok) throw new Error(`${label} template fetch failed (${res.status}): ${url}`);
  cache.bytes = new Uint8Array(await res.arrayBuffer());
  return cache.bytes;
}

export function resetPdfTemplateCache(cache: PdfTemplateCache): void {
  cache.bytes = null;
}
